// extracted by css-extract-rspack-plugin
export default {"searchInput":"lAxWM1KSos5PrYig__searchInput___"};